export default class ObjetoEnviarFiltros {
  constructor(
    adquirente = "",
    destinatario = "",
    finalidade = "",
    origem = "",
    ufDestino = ""
  ) {
    this.adquirente = adquirente;
    this.destinatario = destinatario;
    this.finalidade = finalidade;
    this.origem = origem;
    this.ufDestino = ufDestino;
  }
}



// WEBPACK FOOTER //
// ./src/models/objetoEnviarFiltros.js